import { render, staticRenderFns } from "./allincome.vue?vue&type=template&id=7936070c&scoped=true"
import script from "./allincome.vue?vue&type=script&lang=js"
export * from "./allincome.vue?vue&type=script&lang=js"
import style0 from "./allincome.vue?vue&type=style&index=0&id=7936070c&prod&lang=less&scoped=true"
import style1 from "./allincome.vue?vue&type=style&index=1&id=7936070c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7936070c",
  null
  
)

export default component.exports